// extracted by mini-css-extract-plugin
export default {"wrapper":"authLayout_wrapper__+kMi+","card":"authLayout_card__uGpMs"};